import { UsageTrackerContextPage } from '@csp/csp-common-analytics';

const createCanonicalURL = (canonicalUrl: string, searchParams: string): string =>
  canonicalUrl.indexOf('?') > -1 ? canonicalUrl : canonicalUrl + searchParams;

const removeHash = (href: string): string => {
  const hashIdx = href.indexOf('#');
  return hashIdx === -1 ? href : href.slice(0, hashIdx);
};

const parseCanonicalPath = (canonicalUrl: string): string => {
  try {
    return new URL(canonicalUrl).pathname;
  } catch (_e) {
    // We assume that if the canonical URL is invalid, it's a raw path.
    return canonicalUrl[0] === '/' ? canonicalUrl : `/${canonicalUrl}`;
  }
};

const create = (): UsageTrackerContextPage => {
  const canonicalUrl = document.querySelector("link[rel='canonical']")?.getAttribute('href') ?? undefined;
  const { search, pathname, href } = location;
  const { title, referrer } = document;

  const path = canonicalUrl ? parseCanonicalPath(canonicalUrl) : pathname;
  const newUrl = canonicalUrl ? createCanonicalURL(canonicalUrl, search) : removeHash(href);

  return {
    path,
    referrer,
    search,
    title,
    url: newUrl,
  };
};

export const PageContext = {
  create,
};
